// environment.dev.ts
export const environment = {
    production: true,
    apiUrl: '/api',
    findApiUrl: '/api/find',
    mapbox: {
      accessToken: 'pk.eyJ1IjoiZHJmYWxrZW4iLCJhIjoiY204cHlqYzF3MGg3YTJqcHM5M2JsaXAwbCJ9.eC6LbzLqsO69DRE5I2NlNw' 
    }
  };